import { stringify as qsStringify, parse as qsParse } from 'qs'

export function getSelectedOptions(selectEl) {
  return Array.from(selectEl.querySelectorAll('option[selected]'))
}

export function matchesMediaQuery(mq) {
  return Boolean(window?.matchMedia(mq).matches)
}

export function debounce(func, delay) {
  let timerId

  return function (...args) {
    clearTimeout(timerId)

    timerId = setTimeout(() => {
      func.apply(this, args)
    }, delay)
  }
}

export function getReadingTime(text = '') {
  const wpm = 250
  const words = text.split(/\s+/).length

  return Math.ceil(words / wpm)
}

export function bytesToMegabytes(number) {
  return number / 1048576
}

export function getNiceFileSize(number) {
  if (number >= 1024 && number < 1048576) {
    return `${(number / 1024).toFixed(1)} KB`
  } else if (number >= 1048576) {
    return `${bytesToMegabytes(number).toFixed(1)} MB`
  }

  return `${number} B`
}

export function isEmptyObject(obj) {
  return Object.entries(obj).length === 0
}

export function getUrlState() {
  return qsParse(window.location.search, { ignoreQueryPrefix: true })
}

export function setUrlState(newState, arrayFormat = 'indices') {
  history.replaceState(
    {},
    '',
    isEmptyObject(newState)
      ? './'
      : `?${qsStringify(newState, {
          arrayFormat,
          encode: false,
        })}`,
  )
}

export function formdataToObject(formData) {
  const object = {}

  formData.forEach((value, key) => {
    // NOTE Reflect.has in favor of: object.hasOwnProperty(key)
    if (!Reflect.has(object, key)) {
      object[key] = value
      return
    }
    if (!Array.isArray(object[key])) {
      object[key] = [object[key]]
    }
    object[key].push(value)
  })

  return object
}
